/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'classnames',
	'prop-types'
], function (React, classnames, PropTypes) {

	/**
	 * Normally in React, when flipping between different 'pages' in a UI, you'd simply conditionally
	 * include their markup. In some cases you may want their markup to persist even if not visible.
	 * Rather than custom-writing this logic in your component, CachingPageContainer keeps markup
	 * in the DOM even if not visible.
	 */
	class CachingPageContainer extends React.Component {
		static propTypes = {
			pages: PropTypes.arrayOf(
				PropTypes.shape({
					id: PropTypes.string.isRequired,
					component: PropTypes.func.isRequired,
					className: PropTypes.string,
					props: PropTypes.func
				}).isRequired
			).isRequired,
			currentPageId: PropTypes.string.isRequired,
			className: PropTypes.string
		};

		render() {
			const classNames = { pageContainer: true };
			if(this.props.className) {
				classNames[this.props.className] = true;
			}
			return (
				<div className={classnames(classNames)}>
					{this.props.pages.map(({ id, component: Component, props, className }) => {
						const isVisible = (id === this.props.currentPageId);
						const classNames = {
							containerPage: true,
							currentContainerPage: isVisible
						};
						if(className) {
							classNames[className] = true;
						}
						return (
							<div
								key={id}
								className={classnames(classNames)}
								style={{
									display: isVisible ? 'inherit' : 'none'
								}}
							>
								<Component
									isVisible={isVisible}
									{... props && props() || {}}
								/>
							</div>
						);
					})}
				</div>
			);
		}
	}

	return CachingPageContainer;
});
